// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
/* eslint-disable filename-export/match-default-export */
import React, { useState } from 'react';
import pt from 'prop-types';

import { MrButtonList, MrH, MrModal } from '@ion/components';
import { Button, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@metarouter-private/mr-mui';

import styles from './index.module.scss';

import { onSaveRevision } from './on-save-revision';
import { selectFile } from './select-file';
import FileRequirements from './FileRequirements';
import FileSelect from './FileSelect';
import buildTypeOptions from './buildTypeOptions';
import useUploadValidation from './useUploadValidation';

const UploadModal = ({ playbookState, integration, uploadState, canUploadPlaybook, canUploadConnection }) => {
  // upload: { result, extension, type } once a file is parsed, else null
  const [upload, setUpload] = useState(null);

  const uploadType = upload?.type ?? null;
  const typeOptions = buildTypeOptions({ canUploadPlaybook, canUploadConnection });
  const allowedTypes = typeOptions.map(option => option.value);
  const selectedType = typeOptions.some(option => option.value === uploadType) ? uploadType : null;

  const { validated } = useUploadValidation({ upload, playbookState, integration, uploadState, allowedTypes });

  // ToggleButtonGroup fires onChange with null when the active button is re-clicked;
  // ignore it so the type can't be cleared to nothing.
  const handleTypeChange = (event, newType) => {
    if (newType) {
      setUpload(current => ({ ...current, type: newType }));
    }
  };

  return (
    <MrModal closeModal={uploadState.resetModal}>
      <div className={styles.modalHeader}>
        <MrH h="h2" styleNames="sans">
          Upload
        </MrH>
      </div>

      <div className={styles.modalcontent}>
        <>
          <Stack spacing={2}>
            <FileSelect accept=".json, .yml, .yaml" onChange={event => selectFile({ event, uploadState, setUpload })} />
            <FileRequirements />
            {upload && typeOptions.length > 0 && (
              <Stack spacing={0.5}>
                <Typography variant="caption" color="text.secondary">
                  File type
                </Typography>
                <ToggleButtonGroup exclusive fullWidth size="small" value={selectedType} onChange={handleTypeChange}>
                  {typeOptions.map(option => (
                    <ToggleButton key={option.value} value={option.value}>
                      {option.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Stack>
            )}
          </Stack>

          {uploadState.error && (
            <div className={styles.errorDetails}>
              <Typography variant="body2" color="error">
                Upload Error: {uploadState.error}
              </Typography>
            </div>
          )}

          <MrButtonList
            styleNames="marginTop"
            buttons={[
              <Button
                key="save"
                size="large"
                onClick={() =>
                  onSaveRevision({
                    uploadedData: upload?.result,
                    uploadType,
                    playbookState,
                    uploadState,
                  })
                }
                disabled={Boolean(!validated || uploadState.error)}
              >
                Apply
              </Button>,
              <Button key="cancel" variant="link" size="large" onClick={uploadState.resetModal}>
                Cancel
              </Button>,
            ]}
          />
        </>
      </div>
    </MrModal>
  );
};

UploadModal.propTypes = {
  integration: pt.object.isRequired,
  playbookState: pt.object.isRequired,
  uploadState: pt.shape({
    setError: pt.func.isRequired,
    uploadPermissionOptions: pt.object.isRequired,
    resetModal: pt.func.isRequired,
    error: pt.string,
  }).isRequired,
  canUploadPlaybook: pt.bool,
  canUploadConnection: pt.bool,
};

export default UploadModal;
